import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';
import './bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
